import { ROUTE } from '../actions/types';
import createReducer from './createReducer';


const generalReducer = {
  [ROUTE.SAVE_LOCATION]: (prevState, payload) => ({ location: payload }),
};

export default createReducer({}, generalReducer);
